import { render, staticRenderFns } from "./NeoparentChangePass.vue?vue&type=template&id=6cfbb8b6&scoped=true"
import script from "./NeoparentChangePass.vue?vue&type=script&lang=js"
export * from "./NeoparentChangePass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbb8b6",
  null
  
)

export default component.exports